import { BackwardIcon } from '@heroicons/react/24/solid';
import { MediaSeekBackwardButton } from 'media-chrome/react';
import { CSSProperties } from 'react';

import { Button } from '@/components/atoms/Button';
import { HeroIcon } from '@/components/atoms/Icon';

import { defaultButtonStyling } from './util';

interface Props {
  disabled?: boolean;
}

export function PlayerSeekBackwardButton({ disabled = false }: Props) {
  return (
    <div>
      <MediaSeekBackwardButton
        style={
          {
            '--media-control-background': 'transparent',
            '--media-control-hover-background': 'transparent',
            ...defaultButtonStyling,
          } as CSSProperties
        }
        seekOffset={10}
        disabled={disabled}
      >
        <span slot="icon">
          <Button aria-hidden="true" tabIndex={-1} variant="ghost" size="md">
            <HeroIcon icon={BackwardIcon} />
          </Button>
        </span>
      </MediaSeekBackwardButton>
    </div>
  );
}
